import React from 'react';
import {
  Fade,
  Text,
  Button,
} from 'ui';
import { WhatsAppIcon } from '@assets/icons';
import { tscope } from '@i18n/index';
import { useController } from './hooks';
import { style as s } from './whatsAppWidget.style';

const ts = tscope('Common.brand');

export const WhatsAppWidget = () => {
  const {
    isOpen,
    whatsAppNumber,
  } = useController();

  const whatsAppText = ts('whatsAppVIPDocumentsText');

  return (
    <Fade in={isOpen}>
      <Button
        as="a"
        href={ts('whatsAppMe', { number: whatsAppNumber, text: whatsAppText })}
        target="_blank"
        data-testid="whatsAppWidget"
        {...s.button}
      >
        <WhatsAppIcon
          {...s.icon}
          data-testid="whatsAppWidgetIcon"
        />
        <Text
          style={{ textWrap: 'balance' }}
          {...s.text}
        >
          {ts('whatsAppDocumentsText')}
        </Text>
      </Button>
    </Fade>
  );
};
